import request from '@/service/request'

export default {
  ...request,
  base_url: 'https://staging.api-huaydragon.com/report/',

  getURL() {
    return this.base_url
  },

  // ดึง Settlement Report (readonly)
  async getReport(params) {
    const queryString = new URLSearchParams(params).toString()
    return this.getAuthen(`settlement?${queryString}`)
  },
}
